// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2dF0Q","colBig":"styles_colBig__3cB_S","colSmall":"styles_colSmall__3C-ru","shopifyNameWrapper":"styles_shopifyNameWrapper__2tncM"};